import request from '@/utils/request'
import request2 from '@/utils/request2'

export function sendSms (params) {
  return request({
    method: 'get',
    params: {
      do: 'sendSms',
      ...params
    }
  })
}

export function sendSms915 (params) {
  return request2({
    url: `/notification/sendSms`,
    method: 'post',
    data: {
      ...params
    }
  })
}
